module.exports = __webpack_public_path__ + "img/4_Proximal.7ff103de.png";